import Button from "@app/sharedComponents/Button/Button";
import {  ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";

const ChargesSheet = ({chargesDue,goToTransactions,closeBottomSheet})=>{
    return(
        <ThemedView p="lg">
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center"  mb="lg">
            <ThemedText variant="h5s" color="text-primary">Outstanding charges</ThemedText>

            </ThemedView>
            <ThemedView 
                mb="lg"
                flex={1}
                flexDirection="row"
                flexWrap='wrap' 
                p="lg" 
                backgroundColor="bg-fill-info"
                borderRadius="sm"
            >
                <ThemedText variant="b3r" color='text-secondary'>
                There are outstanding charges of Rs.{formatIndianCurrency(chargesDue)} on your loan account.
                </ThemedText> 
                <ThemedText variant="b3r" color='text-secondary'>
                Details of charges are available in account statement. To view details,<Button label=" click here" type="TEXT" handlePress={goToTransactions} />
                </ThemedText> 
               
            </ThemedView>
            <Button label="Ok, got it!" handlePress={closeBottomSheet} type="SOLID"/>

        </ThemedView>
    )
}

export default ChargesSheet;   